export default "__VITE_ASSET__Dc4w40rR__"